<template>
  <div class="shop-request-new">
    <md-layout md-align="center">
      <md-layout md-flex="80">
        <p>全国の日本酒にこだわりのある居酒屋・酒販店さん情報を募集しています!</p>
      </md-layout>
      <md-snackbar md-position='top center' ref='error'>
        <span>{{snackbarMsg}}</span>
      </md-snackbar>
      <md-layout class="request-form" md-tag="md-card" md-column md-flex="80">
        <md-card-content>
          <form novalidate @submit.stop.prevent="onSubmit">

            <md-input-container v-bind:class="{ 'md-input-invalid': hasError.name }">
              <md-icon class="md-home">home</md-icon>
              <label>店舗名</label>
              <md-input required class="f-txt" v-model="name"></md-input>
            </md-input-container>

            <md-input-container v-bind:class="{ 'md-input-invalid': hasError.station }">
              <md-icon class="md-train">train</md-icon>
              <label>最寄駅</label>
              <md-input required  class="f-txt" v-model="station"></md-input>
            </md-input-container>

            <md-input-container v-bind:class="{ 'md-input-invalid': hasError.comment }">
              <md-icon class="md-comments">comments</md-icon>
              <label>オススメポイント</label>
              <md-input required class="f-txt" v-model="comment"></md-input>
            </md-input-container>

            <md-layout md-align="center">
              <md-button type="submit" class="md-raised md-primary">送信</md-button>
            </md-layout>
          </form>
        </md-card-content>
      </md-layout>
    </md-layout>
  </div>
</template>

<script>
import firebaseApp from '../../firebaseApp'
import router from '../../router/index'
import moment from 'moment'
const db = firebaseApp.firestore()
const shopsRequestRef = db.collection('shop_requests')

let data = {
  name: '',
  station: '',
  comment: '',
  created_at: '',
  hasError: { name: false, station: false, comment: false },
  snackbarMsg: ''
}

export default {
  name: 'shop-request-new',
  data () {
    return data
  },
  watch: {
    name: function () {
      this.watchValue('name')
    },
    station: function () {
      this.watchValue('station')
    },
    comment: function () {
      this.watchValue('comment')
    }
  },
  mounted () {
    document.getElementsByClassName('shop-request-new')[0].style.height = document.documentElement.clientHeight + 'px'
    this.$material.setCurrentTheme('shop_requests')
  },
  destroyed () {
    this.$material.setCurrentTheme('default')
  },
  methods: {
    onSubmit: function () {
      if (this.isValid) {
        const now = moment().toDate()
        shopsRequestRef.add({ name: data.name, station: data.station, comment: data.comment, created_at: now
        }).then(() => {
          data.name = ''
          data.station = ''
          data.comment = ''
          data.hasError.name = false
          data.hasError.station = false
          data.hasError.comment = false
          router.push({name: 'ShopRequestsThanks'})
        }).catch(function () {
          data.snackbarMsg = '投稿に失敗しました。もう一度送信ボタンを押してください。'
          this.$refs.error.open()
        })
      } else {
        data.snackbarMsg = '未入力の項目があります'
        this.$refs.error.open()
      }
    },
    watchValue: function (key) {
      if (data[key] === '') {
        data.hasError[key] = true
      } else {
        data.hasError[key] = false
      }
    }
  },
  computed: {
    validation: function () {
      return { name: !!data.name, station: !!data.station, comment: !!data.comment }
    },
    isValid: function () {
      const validation = this.validation
      this.watchValue('name')
      this.watchValue('station')
      this.watchValue('comment')
      return Object.keys(validation).every(key => {
        this.watchValue(key)
        return validation[key]
      })
    }
  }
}
</script>

<style scoped>
.shop-request-new {
  background-image: url('../../assets/bg.png')
}

.request-form {
  margin-top: 40px;
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/ShopRequests/New.vue